module.exports = __webpack_public_path__ + "static/media/57_tn.5af955a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/57_tn.jpg
// module id = 545
// module chunks = 0